<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title">Cambia Veicolo al Viaggio </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">

        <div class="input-group mb-3">
            <button class="btn btn-danger col-12" (click)="viewVehiclesAvailable()">
                Visualizza veicoli disponibili
            </button>
        </div>
        <div class="input-group mb-1">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon14">Cerca per targa</span>
            </div>
            <input type="text" class="form-control" placeholder="Targa" (input)="onPlateChanged(plateInput.value)"
                   #plateInput aria-label="Targa" aria-describedby="basic-addon1" [(ngModel)]="selectedPlate">
        </div>

        <ul class="list-group mb-3" style="width:100%;" #listGroup [hidden]="mydataz.vehicles.length == 0">
            <li class="list-group-item" style="  font-size: 10px; padding: 10px;"
                *ngFor="let vehicle of mydataz.vehicles"
                [class.active]="vehicleToSet === vehicle"
                (click)="vehicleSelected(vehicle)">{{vehicle.plate}} {{vehicle.model.name}} {{vehicle.model.brand.name}}</li>
        </ul>

        <div class="input-group mb-1">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon165">Targa</span>
            </div>
            <input type="text" class="form-control" placeholder="Targa" [ngModel]="vehicleToSet.plate"
                   aria-label="Targa" aria-describedby="basic-addon1" disabled>
        </div>

        <div class="input-group mb-1">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon16">Marca</span>
            </div>
            <input type="text" class="form-control" placeholder="Marca" [ngModel]="vehicleToSet.model.brand.name"
                   aria-label="Marca" aria-describedby="basic-addon1" disabled>
        </div>

        <div class="input-group mb-1">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon17">Modello</span>
            </div>
            <input type="text" class="form-control" placeholder="Modello" [ngModel]="vehicleToSet.model.name"
                   aria-label="Modello" aria-describedby="basic-addon1" disabled>
        </div>

        <div class="input-group mb-1">
            <div class="input-group-prepend">
                <span class="input-group-text">Classe</span>
            </div>
            <input type="text" class="form-control" placeholder="Classe" [ngModel]="vehicleToSet.type.name"
                   aria-label="Classe" aria-describedby="basic-addon1" disabled>
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Sottoclasse</span>
            </div>
            <input type="text" class="form-control"
                   placeholder="Sottoclasse" [(ngModel)]="vehicleToSet.type.supertype.name"
                   aria-label="Sottoclasse" aria-describedby="basic-addon1" disabled>
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Parco mezzi</span>
            </div>
            <input type="text" class="form-control"
                   placeholder="Parco" [(ngModel)]="vehicleToSet.park.name"
                   aria-label="Parco" aria-describedby="basic-addon1" disabled>
        </div>

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modalRef.hide()">Annulla</button>
        <button type="button"
                class="btn btn-secondary"
                [disabled]="dom_elements.assign_btn.is_running"
                data-dismiss="modal"
                (click)="changeVehicle()">
            {{ dom_elements.assign_btn.is_running ?
            dom_elements.assign_btn.txt_run :
            dom_elements.assign_btn.txt_not_run}}
        </button>
    </div>

</ng-template>
<app-assign-available-car-to-user (vehicleSelected)="setVehicleFromAvailables($event)"
                                  [travel]="travelToChange"></app-assign-available-car-to-user>
